<template>
    <br />
    <h3>Charges</h3>
    <br />
    <div class="mb-3">
        <SelectButton v-model="chargeType" :options="chargeTypeOptions" @click="chargeTypeFilter()">
        </SelectButton>
    </div>

    <DataTable :value="charges" v-show="charges.length > 0 || loadingCharges" ref="chargesTable" :rowClass="rowClass"
        class="p-datatable-sm" responsiveLayout="stack" stripedRows breakpoint="992px" :lazy="true"
        :loading="loadingCharges" v-model:expandedRows="expandedRowsCharges"
        tableClass="border-left border-right border-bottom" dataKey="id" id="charges-table" sortField="transaction_date"
        :sortOrder="1">
        <Column class="expander" :expander="true" headerStyle="width: 3em" />
        <Column class="date" field="transaction_date" header="Date" :sortable="true">
            <template #body="slotProps">
                {{ moment(slotProps.data.transaction_date).format('M/D/YY h:mm A') }}
            </template>
        </Column>
        <Column field="description" header="Description">
            <template #body="slotProps">
                <inertia-link v-if="slotProps.data.link" :href="route(slotProps.data.link[0], slotProps.data.link[1])">
                    {{ slotProps.data.modifiedDescription }}
                </inertia-link>
                <span class="text-right" v-else>
                    {{ slotProps.data.modifiedDescription }}
                </span>
                <span v-if="slotProps.data.modifiedNotes" class="text-secondary">
                    &nbsp; {{ slotProps.data.modifiedNotes }}
                </span>
            </template>
        </Column>
        <Column field="due_date" header="Date Due" :sortable="true">
            <template #body="slotProps">
                <template v-if="slotProps.data.balance == 0">
                    <span class="text-success">Paid</span>
                </template>
                <template v-else-if="slotProps.data.due_date">
                    <span :class="{ 'text-danger': moment(slotProps.data.due_date).isBefore(this.now) }">{{
                        moment(slotProps.data.due_date).format('M/D/YY') }}</span>
                </template>
            </template>
        </Column>
        <Column class="table-right" field="balance" header="Amount Owed / Total" headerClass="header-right">
            <template #body="slotProps">
                <span>{{ formatDollars(slotProps.data.balance) }}</span><span v-if="slotProps.data.chargeAmount > 0"> / {{
                    formatDollars(slotProps.data.chargeAmount) }}</span>
            </template>
        </Column>
        <template #expansion="slotProps">
            <DataTable :value="slotProps.data.details" class="p-datatable-sm" responsiveLayout="stack" stripedRows
                breakpoint="992px" tableClass="border-left border-right border-bottom" dataKey="id" id="details-table"
                sortField="transaction_date" :sortOrder="1">
                <Column class="date" field="transaction_date" header="Date" :sortable="true">
                    <template #body="slotProps">
                        {{ moment(slotProps.data.transaction_date).format('M/D/YY h:mm A') }}
                    </template>
                </Column>
                <Column field="description" header="Description">
                    <template #body="slotProps">
                        <inertia-link v-if="slotProps.data.link"
                            :href="route(slotProps.data.link[0], slotProps.data.link[1])">
                            {{ slotProps.data.modifiedDescription }}
                        </inertia-link>
                        <span class="text-right" v-else>
                            {{ slotProps.data.modifiedDescription }}
                        </span>
                        <span v-if="slotProps.data.modifiedNotes" class="text-secondary">
                            &nbsp; {{ slotProps.data.modifiedNotes }}
                        </span>
                    </template>
                </Column>
                <Column field="due_date" header="Date Due" :sortable="true">
                    <template #body="slotProps">
                        <template v-if="slotProps.data.balance == 0">
                            <span class="text-success">Paid</span>
                        </template>
                        <template v-else-if="slotProps.data.due_date">
                            <span :class="{ 'text-danger': moment(slotProps.data.due_date).isBefore(this.now) }">{{
                                moment(slotProps.data.due_date).format('M/D/YY') }}</span>
                        </template>
                    </template>
                </Column>
                <Column class="table-right" field="balance" header="Amount Owed / Total" headerClass="header-right">
                    <template #body="slotProps">
                        <span>{{ formatDollars(slotProps.data.balance) }}</span><span
                            v-if="slotProps.data.chargeAmount > 0"> / {{ formatDollars(slotProps.data.chargeAmount)
                            }}</span>
                    </template>
                </Column>
            </DataTable>
        </template>
    </DataTable>
    <div v-if="!loadingCharges && charges.length === 0">
        <br />
        <h3 style="text-align: center;">No Transactions</h3>
    </div>
</template>

<script>
import SelectButton from 'primevue/selectbutton'
import moment from 'moment'

export default {
    data() {
        return {
            charges: [],
            expandedRowsCharges: [],
            chargeType: 'Unpaid',
            now: moment(),
            chargeTypeOptions: [
                'Unpaid',
                'Paid',
                'Credits',
            ],
            loadingCharges: false,
        }
    },
    watch: {
        '$page.props': function () {
            this.chargeTypeFilter()
        },
    },
    components: {
        SelectButton,
    },
    created() {
        this.moment = moment;
    },
    async mounted() {
        this.loadingCharges = true;
        await this.$inertia.form({}).post(this.route('mtd.billing', 'charges'), {
            preserveState: true,
            preserveScroll: true,
            resetOnSuccess: true,
            only: ['charges'],
            onSuccess: () => {
                this.loadingCharges = false;
            },
            onError: () => {
                this.loadingCharges = false;
            },
        });
    },
    methods: {
        rowClass: (data) => {
            return [
                { 'empty-details': (data.details || []).length == 0 }
            ];
        },
        chargeTypeFilter() {
            this.$refs['chargesTable'].resetPage();
            this.charges = (this.$page.props?.charges || []).filter(elem => {
                switch (this.chargeType) {
                    case 'Unpaid':
                        return elem.balance > 0;
                    case 'Paid':
                        return elem.balance == 0;
                    case 'Credits':
                        return elem.balance < 0;
                }
            })
        },
    }
}
</script>
<style lang="scss">
.empty-details .expander {
    visibility: hidden;
}
</style>
